import React, { useState } from 'react';
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import './TravelArrangementFaq.css';

const TravelArrangementFaq = () => {
    const [activeIndex, setActiveIndex] = useState(null);

    const questions = [
        { question: "How does Blueberry Travels ensure my safety during trips?", answer: "We take a bold approach to travel safety, offering customized safety plans for every trip. From pre-departure briefings and health protocols to real-time traveler tracking and emergency assistance, we ensure that you’re supported at every stage." },
        { question: "Can Blueberry Travel assist with last-minute changes or emergencies?", answer: "Absolutely! Whether you need to modify your booking, adjust travel plans due to unforeseen events, or need emergency support during your journey, our 24/7 customer care team is always there to help you stay on track." },
        { question: "How do you handle health and safety precautions in different destinations?", answer: "Blueberry Travel keeps you informed about the latest health and safety guidelines specific to your destination. Our Corporate Booking Tool offers real-time updates, ensuring you’re always aware of travel restrictions, required vaccinations, and any regional health protocols. " },
        { question: "What makes Blueberry Travel’s safety approach different from other travel companies?", answer: "Our approach is personalized. From customized safety plans based on your destination and trip type to providing cultural insights, Blueberry Travel goes beyond just ensuring physical safety. We focus on creating a flawless, safe, and enriching travel experience from start to finish." },
        { question: "How does Blueberry Travel’s traveler tracking system work?", answer: "Our Traveler App offers full visibility into your itinerary and real-time location updates. Travel managers and travelers can easily monitor current travel conditions, weather forecasts, flight trackers, and more. In an emergency, our system activates instant notifications and allows for quick action." },
        { question: "How do you ensure that your health and safety guidelines are up-to-date?", answer: "Our team continuously monitors global health advisories and updates our guidelines accordingly. We work closely with international health organizations and local authorities to ensure that our information is accurate and current. " },
    ];

    const toggleFAQ = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <div className="container ta-faq">

            <h2 className='headings mt-2 mx-3  safetyCardHeading'><span>Frequently</span> Asked Questions</h2>
            <div className="travelfaq-list">
                {questions.map((item, index) => (
                    <div
                        key={index}
                        className={`travelfaq-item ${activeIndex === index ? 'active' : ''}`}
                    >
                        <div className="travelfaq-question  " onClick={() => toggleFAQ(index)}>
                            {item.question}
                            <LazyLoadImage
            effect="blur"
 src={activeIndex === index ? "https://blueberrywebsites.azureedge.net/bbt/images/faqMInus.png" : "https://blueberrywebsites.azureedge.net/bbt/images/faqAdd.png"}
                                alt={activeIndex === index ? 'Collapse' : 'Expand'}
                                className="travelFaqIcon" loading="lazy" 
                            />
                        </div>
                        {activeIndex === index && (
                            <div className="travelfaq-answer">{item.answer}</div>
                        )}
                    </div>
                ))}
            </div>

        </div>
    );
};

export default TravelArrangementFaq;
